import { render, staticRenderFns } from "./ContractInformation.vue?vue&type=template&id=50e4c80e&scoped=true"
import script from "./ContractInformation.vue?vue&type=script&lang=js"
export * from "./ContractInformation.vue?vue&type=script&lang=js"
import style0 from "./ContractInformation.vue?vue&type=style&index=0&id=50e4c80e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e4c80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e4c80e')) {
      api.createRecord('50e4c80e', component.options)
    } else {
      api.reload('50e4c80e', component.options)
    }
    module.hot.accept("./ContractInformation.vue?vue&type=template&id=50e4c80e&scoped=true", function () {
      api.rerender('50e4c80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ContractInformation.vue"
export default component.exports